import { TableCellProps } from "@/components/table/table-cell";
import { formatIsoAsWib } from "@/utils/helper/formatDate";
import getNestedValue from "@/utils/helper/getNestedValue";
import { resolveActionUrl } from "@/utils/helper/resolveActionUrl";
import { Link } from "react-router-dom";
import NotificationReadCheckboxCell from "./NotificationReadCheckboxCell";

// Tambahkan custom cell component
export default function NotificationCustomCol(props: TableCellProps) {
  const { name, rowValue, defaultCell } = props;

  // Tambahkan case khusus di sini
  switch (name) {
    case "notification.message": {
      const content = (
        <>
          <b>{getNestedValue(rowValue, "notification.statusData") as string}</b>
          <br />
          <p>{getNestedValue(rowValue, name) as string}</p>
        </>
      );

      return getNestedValue(rowValue, "notification.type") === "TODO" ? (
        <Link
          to={resolveActionUrl(
            getNestedValue(rowValue, "notification.actionUrl") as string,
          )}
          className="block w-80 cursor-pointer text-wrap hover:underline"
        >
          {content}
        </Link>
      ) : (
        <span className="block w-80 text-wrap">{content}</span>
      );
    }
    case "createdDate":
      return (
        <span className="text-wrap">
          {formatIsoAsWib(getNestedValue(rowValue, name) as string)}
        </span>
      );
    case "isRead":
      return <NotificationReadCheckboxCell name={name} rowValue={rowValue} />;
    case "notification.type":
      return (
        <span
          className={`w-min text-nowrap rounded-full p-2 ${
            getNestedValue(rowValue, name) === "TODO"
              ? "bg-orange-50 text-orange-700"
              : "bg-blue-50 text-blue-700"
          }`}
        >
          {getNestedValue(rowValue, name) as string}
        </span>
      );
    default:
      return defaultCell;
  }
}
